<template>

<app-content-box class="details" :not-padded="true" :freeze="status === $constants.status.loading">

	<div class="details-wrapper">

		<div class="profile-photo">

			<div class="profile-photo-preview" :class="{'has-photo': model.photo}" v-bgimage="model.photo">

				<template v-if="!model.photo">No photo</template>

			</div>

			<app-input-image v-if="!isCancelled" :as-toolbar="true" :disabled="!isActive" :hide-preview="true" :allow-webcam="true" v-model="model.photo" :validation="$v.model.photo" />

        </div>

		<div class="details-form">

			<app-input-text label="E-mail" v-model="model.email" :locked="true" :disabled="true" :validation="$v.model.email" placeholder="Enter your email" />
			<app-input-text label="First name" v-model="model.firstname" :locked="!isActive" :disabled="!isActive" :validation="$v.model.firstname" placeholder="Enter your first name" maxlength="32" />
			<app-input-text label="Last name" v-model="model.lastname" :locked="!isActive" :disabled="!isActive" :validation="$v.model.lastname" placeholder="Enter your last name" maxlength="32" />

		</div>

	</div>

</app-content-box>

</template>

<script>

import mixForm from '@/mixin/form'
import { required } from 'vuelidate/lib/validators'

export default {

	mixins: [mixForm],

	props: ['subscription', 'preview'],

	data: function() {

		return {
			is: {
				generating: true
			},
			standalone: true,
			status: false,
			model: {
                photo: '',
				firstname: '',
				lastname: ''
			}
		}

	},
	
	validations: {
		model: {
			firstname: {
				required
			},
			lastname: {
				required
			}
		}
	},

	created: function() {

		this.model.photo = this.subscription.photo
		this.model.email = this.subscription.email
		this.model.firstname = this.subscription.firstname
		this.model.lastname = this.subscription.lastname

	},

    computed: {
    
        isActive: function() {
		
			return this.subscription.status === 1
		
		},

    },

	watch: {
	
		model: {
		
			deep: true,

			handler: function(n) {
			
				this.$emit('change', n)
			
			}
		
		}

	},

	methods: {

		onSubmitClick: function() {

			this.status = this.$constants.status.loading

			this.$api.put('membership/subscription', this.model).then(function() {

				this.status = this.$constants.status.success

				this.is.generating = true

				this.$emit('changed')
				
			}.bind(this), function() {

				this.status = this.$constants.status.failed

			}.bind(this))

		}

	}

}

</script>

<style scoped>

.is-mobile .details {
	margin-bottom: 0px!important;
}

.details >>> .box-content {
    height: 100%;
}

.is-mobile .details >>> .box-content {
	height: auto;
}

.details-wrapper {
	display: flex;
}

.profile-photo {
    width: 220px;
    padding: 20px;
    height: 240px;
    flex-shrink: 0;
}

.is-mobile .profile-photo {
	width: 100%;
}

.profile-photo-preview {
	width: 180px;
	height: 180px;
	border: 2px solid #eeeeee;
	color: #ccc;
	line-height: 176px;
	text-align: center;
	font-size: 16px;
	border-radius: 10px;
	font-weight: 400;
	background-position: 50% 50%;
	background-size: contain;
	background-repeat: no-repeat;
}

.is-mobile .profile-photo-preview {
	width: 100%;
}

.profile-photo-preview.has-photo {
	background-color: #000;
	border: 0px;
}

.is-mobile .details-wrapper {
	flex-direction: column;
}

.details-preview {
	border-right: 1px solid #eee;
	flex-shrink: 0;
	width: 385px;
	height: 288px;
}

.is-mobile .details-preview {
	width: 100%;
	height: auto;
	border-right: 0px;
	border-bottom: 1px solid #eee;
}

.is-mobile .details-preview img {
	max-width: 100%;
}

.details-preview.is-loading .details-preview-image {
	opacity: 0;
}

.details-preview-loading {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	font-size: 32px;
	color: #ffbe7a;
}

.details-form {
	padding: 20px;
	flex-grow: 1;
}

.details-form p {
	font-size: 14px;
	line-height: 18px;
	margin-bottom: 20px;
}

</style>
